var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"defaultHome"},[_c('headerBar'),_c('div',{staticClass:"defaultHome-lump"}),_c('div',{staticClass:"defaultHome-content-wrap"},[_c('menuBar',{staticClass:"menuBar"}),_c('div',{staticClass:"main-wrap"},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }